import React from "react";
import "../styles/categorypage.css";
import Footer from "../components/footer";  // Import Footer component
import CategoriesComponent from "../components/categories"; // Renamed to avoid conflict
import SEOHead from "../components/SEOHead";

const CategoriesPage = () => {
  return (
    <div>
      <SEOHead
        title="Sleep Categories - Expert Articles by Topic"
        description="Browse all sleep categories including sleep hygiene, natural remedies, sleep science, and more. Find expert advice tailored to your sleep needs."
        path="/categories"
      />
      <CategoriesComponent />  
      <Footer />
    </div>
	
  );
}

export default CategoriesPage;
